import { useCallback } from "react";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { IconButton, Tooltip, useColorScheme } from "@mui/material";

const TopbarLightDarkSwitch = () => {
  const { mode, setMode } = useColorScheme();

  const toggleColorMode = useCallback(() => {
    setMode(mode === "light" ? "dark" : "light");
  }, [mode, setMode]);

  return (
    <Tooltip title="Toggle dark mode">
      <IconButton
        onClick={toggleColorMode}
        data-ph-capture-attribute-action="toggle_theme"
      >
        {mode === "light" ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default TopbarLightDarkSwitch;
